const locationsReducer = (
  state = {
    data: null,
    graphSummaryData: {},
    loading: false,
    results: null,
    summaryData: null,
    total: null,
    wards: null,
    zones: null,
    selectedLocation: {
      data: null,
      captures: null,
      attendance: null,
      loading: { captures: false, attendance: false }
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_LOCATIONS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "PUT_LOCATIONS_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "PUT_LOCATIONS_RESULTS":
      return {
        ...state,
        results: action.payload.data
      };

    case "SET_LOCATIONS_COUNT":
      return {
        ...state,
        total: action.payload.count
      };

    case "PUT_ZONE_AND_WARD":
      return {
        ...state,
        wards: action.payload.data.wards,
        zones: action.payload.data.zones
      };

    case "SET_COMPLAINT_SUMMARY_DATA":
      return {
        ...state,
        summaryData: action.payload.data
      };

    case "SET_GRAPH_SUMMARY_DATA":
      return {
        ...state,
        graphSummaryData: { ...state.graphSummaryData, ...action.payload }
      };
    case "SET_LOCATION_ASSETS":
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          data: action.payload.data
        }
      };
    case "PUT_SELECTED_LOCATION_DATA":
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          ...action.payload.data
        }
      };

    case "SET_SELECTED_LOCATION_DATA_CAPTURE_ASSETS":
      if (!state.selectedLocation?.captures) {
        return state;
      }
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          captures: {
            ...state.selectedLocation.captures,
            [action.payload.documentId]: action.payload
          }
        }
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default locationsReducer;
